export const detectZoom = () => {
  let ratio = 0,
    screen = window.screen,
    ua = navigator.userAgent.toLowerCase();
  if (window.devicePixelRatio !== undefined) {
    ratio = window.devicePixelRatio;
  } else if (~ua.indexOf("msie")) {
    if (screen.deviceXDPI && screen.logicalXDPI) {
      ratio = screen.deviceXDPI / screen.logicalXDPI;
    }
  } else if (
    window.outerWidth !== undefined &&
    window.innerWidth !== undefined
  ) {
    ratio = window.outerWidth / window.innerWidth;
  }
  if (ratio) {
    ratio = Math.round(ratio * 100);
  }
  return ratio;
};

export function watchFun() {
  const screen = [];
  var url = window.location.href;
  var isScreen = false;
  screen.forEach((item) => {
    if (url && url.includes(item)) {
      isScreen = true;
    } else {
      isScreen = false;
    }
  });
  const m = detectZoom();
  const c = document.querySelector("body");
  // if (isScreen) {
  //   c.style.zoom = 1;
  // } else {
  // 判断屏幕是否为4k
  // if (window.screen.width * window.devicePixelRatio >= 2560) {
  //   c.style.zoom = 100 / (Number(m) / 2);
  // } else {
  c.style.zoom = 100 / Number(m);
  // }
  // }
}

export function resizeWatchFun() {
  watchFun();
  window.addEventListener("resize", watchFun());
}
